import React from 'react';
import { Provider, useSelector } from 'react-redux';
import { ConfigProvider } from 'antd';
import store, { RootState } from '../store/index';
import { ReactNode } from 'react';

interface ThemeWrapperProps {
    children: ReactNode; // 指定children的类型为ReactNode
}

const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);

    return (
        <ConfigProvider
            theme={{
                components: {
                    Select: {
                        colorPrimary: '#ac9455',
                        colorText:'#33364b',
                        fontSizeIcon: 10,
                        fontSizeLG: 10,
                        fontSize: 12,
                        // optionActiveBg:themeColor,
                    },
                    Button: {
                        defaultBg: '#ac9455'
                    },
                    Input: {
                        activeBorderColor: '#ac9455',
                        activeShadow: '#ac9455',
                        colorIconHover: '#ac9455', 
                        hoverBorderColor: '#ac9455',
                        addonBg:'#ac9455',
                        colorIcon: '#ac9455',
                    }
                },
                token: {
                    colorPrimary: '#ac9455',
                    borderRadius: 2,
                    colorBgContainer: '#ffffff',
                },
            }}
        >
            {children}
        </ConfigProvider>
    );
};

export default ThemeWrapper;